import instObj from '@/backend/axios-instances'

const resource = "/cutsheets"
const instance = instObj.baseInstance

export default {
  post(data, parameters) {
    //need project_id as a param
    return instance.post(`${resource}/assemblies`, data, { params: parameters });
  },
  get(parameters) {
    return instance.get(`${resource}/assemblies`, { params: parameters });
  },
  put(assemblyId, data, parameters) {
    return instance.put(`${resource}/assembly/${assemblyId}`, data, { params: parameters });
  },
  delete(assemblyId, parameters) {
    return instance.delete(`${resource}/assembly/${assemblyId}`, { params: parameters });
  },
  attach(assemblyId, data, parameters) {
    return instance.post(`${resource}/assembly/${assemblyId}/attachment`, data, { params: parameters });
  }
}